import SidebarNavListItem from './SidebarNavListItem';
import React from 'react';
import { NavRoute } from '../../routes';

type ReduceChildRoutesProps = {
  depth: number;
  page: NavRoute;
  items: React.ReactElement[];
  currentRoute: string;
};

const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { items, page } = props;

  items.push(<SidebarNavListItem depth={0} href={page.path} icon={page.navIcon || (() => null)} key={page.navText} title={page.navText ?? ''} />);

  return items;
};

export default reduceChildRoutes;
